import axios from 'axios'
import { get } from 'lodash'
import { action, computed, decorate, observable, reaction } from 'mobx'
import moment from 'moment'
import { v4 as uuid } from 'uuid'

const fetch = (options) => axios(options).then((r) => r.data)

export default class ScheduleStore {
  constructor(store) {
    this.store = store
    this.initialize()
  }

  leagueId = ''
  date = moment()
  gamePks = ''
  gamePkSearchValue = ''
  tab = 'games'
  games = []
  events = []
  leagues = []
  sportId = ''

  set(key, value) {
    this[key] = value
  }

  get sports() {
    return this.store.info.sports || []
  }

  fetch() {
    let id = uuid()

    this._requests[id] = true
    this.games.clear()

    return fetch({
      url: '/api/schedule',
      params: this.params,
    })
      .then(
        action((data) => {
          const { games = [], events = [] } = data
          this.games.replace(
            games.filter((game) => get(game, 'status.codedGameState') !== 'C')
          )
          this.events.replace(events)
        })
      )
      .catch((error) => {
        console.error(error)
      })
      .finally(
        action(() => {
          delete this._requests[id]
        })
      )
  }

  fetchLeagues() {
    let id = uuid()

    this._requests[id] = true
    this.leagues.clear()

    return fetch({
      url: '/api/schedule/leagues',
      params: { sportId: this.sportId },
    })
      .then(
        action((leagues = []) => {
          this.leagues.replace(leagues)
        })
      )
      .catch((error) => {
        console.error(error)
      })
      .finally(
        action(() => {
          delete this._requests[id]
        })
      )
  }

  _requests = {}

  get isLoading() {
    return Object.keys(this._requests).length > 0
  }

  get shouldFetch() {
    return this.store.auth.isAuthenticated
  }

  get params() {
    let { date, sportId, gamePks, leagueId } = this

    return {
      date: date.format('YYYY-MM-DD'),
      sportId,
      leagueId,
      gamePks,
    }
  }

  initialize() {
    if (this.shouldFetch) {
      this.fetch()
      this.fetchLeagues()
    }

    reaction(
      () => ({
        params: this.params,
        shouldFetch: this.shouldFetch,
      }),
      ({ shouldFetch }) => {
        if (shouldFetch) {
          this.fetch()
        }
      }
    )

    reaction(
      () => ({
        sportId: this.sportId,
        shouldFetch: this.shouldFetch,
      }),
      ({ shouldFetch }) => {
        if (shouldFetch) {
          this.fetchLeagues()
        }
      }
    )
    reaction(
      () => this.store.info.bdpTenantConfig.topLevelSportId,
      (topLevelSportId) => {
        if (topLevelSportId && !this.sportId) {
          this.sportId = topLevelSportId
        }
      }
    )
  }
}

decorate(ScheduleStore, {
  leagueId: observable,
  date: observable,
  gamePks: observable,
  gamePkSearchValue: observable,
  tab: observable,
  games: observable,
  events: observable,
  leagues: observable,
  _requests: observable,
  fetch: action,
  shouldFetch: computed,
  params: computed,
  sports: computed,
  sportId: observable,
  set: action,
})
